@charset "UTF-8";

/* src/app/@modules/recuitment-module/bgv/candidate-upload-doc/candidate-upload-doc.component.scss */
.candidateOffer {
  background-image: url("./media/candidate-bg.jpg");
  background-position: top left;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 0 12px;
}
.candidateOffer .candidate_Details {
  width: 85%;
  max-width: 100%;
  margin: 20px auto;
  padding: 0;
}
.candidate_Details .section-title,
.candidate_Details h2 {
  background-color: #00a1b1;
  color: #fff;
  padding: 10px 14px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  margin-bottom: 0;
  font-size: 1.1rem;
}
.candidate_Details .basic_details {
  padding: 16px;
}
.basic-details-row {
  margin-bottom: -8px;
}
.detail-item {
  margin-bottom: 16px;
}
.basic_details h5 {
  font-weight: 500;
  color: #323232;
  font-size: 14px;
  margin-bottom: 4px;
}
.basic_details p {
  color: #8f8f8f;
  font-size: 13px;
  margin: 0;
  word-break: break-word;
}
.full-width {
  width: 100%;
}
.document-row {
  align-items: flex-start;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
}
.document-row:last-of-type {
  border-bottom: none;
}
.document-row.doc-row-error {
  border: 1px solid #f3d6d9;
  border-radius: 8px;
  padding: 12px 16px;
  margin-left: -2px;
  margin-right: -2px;
  background-color: rgba(220, 53, 69, 0.04);
}
.address-field-error {
  border: 2px solid #dc3545;
  border-radius: 8px;
  padding: 8px 12px;
  background-color: rgba(220, 53, 69, 0.04);
}
.address-field-error .mat-mdc-form-field .mdc-notched-outline .mdc-notched-outline__leading,
.address-field-error .mat-mdc-form-field .mdc-notched-outline .mdc-notched-outline__notch,
.address-field-error .mat-mdc-form-field .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: #dc3545 !important;
}
.doc-field {
  margin-bottom: 12px;
}
.doc-upload-field.doc-field {
  margin-top: -12px !important;
  padding-top: 0 !important;
}
.doc-upload-field .form-group {
  display: flex !important;
  flex-direction: column !important;
  padding-top: 0 !important;
  margin-top: 0 !important;
}
.doc-upload-field .form-group .file-upload-row,
.doc-upload-field .file-upload-row {
  margin-top: 6px !important;
}
.candidate-file-input-hidden {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
}
.upload-doc-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 48px;
  padding: 10px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  color: #374151;
  font-size: 14px;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  box-sizing: border-box;
}
.upload-doc-btn:hover {
  border-color: #00a1b1;
  background: #f0f9fa;
  color: #008c99;
}
.upload-doc-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.doc-upload-field .fileRow .file-input {
  margin-top: 0 !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.file-upload-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}
.fileRow {
  flex: 1 1 auto;
  min-width: 0;
}
.file-input {
  width: 100%;
  min-width: 0;
  font-size: 13px;
  padding: 10px 12px;
  min-height: 48px;
  box-sizing: border-box;
}
.doc-actions {
  display: flex;
  align-items: flex-end;
}
.action-buttons {
  display: flex;
  margin-top: 30px;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-top: 22px;
}
.btn-action {
  min-width: 40px;
  min-height: 40px;
  padding: 8px 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.submit-wrap {
  margin-top: 24px;
  padding-top: 16px;
}
.btn-submit {
  min-height: 44px;
  padding: 10px 28px;
  font-size: 1rem;
}
.tableContent thead th {
  color: #070707;
  font-weight: 500;
}
.downloadButton {
  border: 1px solid #00a1b1;
  color: #00aabb !important;
  font-weight: 400;
  font-size: 12px;
  border-radius: 30px;
}
.downloadButton mat-icon {
  color: #00aabb !important;
}
.form_set {
  padding: 0px;
}
.form-group mat-label,
label {
  font-weight: 400;
  float: left;
  font-size: 14px;
  color: #3b3b3b;
  margin-bottom: 6px;
}
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: rgba(232, 213, 233, 0.3019607843);
}
.formBorder .form-group .mdc-text-field--outlined {
  border: none !important;
}
div .btn1 {
  background-color: #207806;
  font-weight: 400;
  padding: 0px 35px;
}
div .btn2 {
  background-color: #a70818;
  font-weight: 400;
  padding: 0px 28px;
}
.btn_employ {
  padding: 20px;
}
.imgEmp {
  width: 41px;
  height: 31px;
  position: relative;
  top: -35px;
  left: 84%;
  border-radius: 5px;
  cursor: pointer;
}
.file_delete {
  width: 33px;
  height: 27px;
  position: relative;
  top: -31.5px;
  left: 259px;
  border-radius: 5px;
}
@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
.spinner:before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  border-top-color: #5d6c7c;
  animation: spinner 0.8s linear infinite;
  margin: 0px 0px 0px 8px;
}
.file_upload1 {
  font-size: 10px;
  margin-left: 5px;
  color: red;
}
.file_upload {
  font-size: 10px;
  margin-left: 5px;
}
.readonly-wrapper {
  pointer-events: none;
}
.form_heads2 {
  text-align: center;
  background-color: #0a46a7;
  color: white;
  cursor: pointer;
}
.formBorder .form-group input {
  font-size: 13px !important;
}
.form_heads1 {
  text-align: center;
  background-color: white;
  color: #0a46a7;
  cursor: pointer;
  border: 1px solid #82b0fa;
}
.emp_codes {
  border-radius: 5px;
  height: 52px;
}
.form-group .form-control {
  font-size: 12px;
}
.codeArea {
  position: relative;
}
.codeArea .addCoding {
  position: absolute;
  top: 20px;
  left: 0px;
  z-index: 999;
  width: 65px;
}
.codeArea .mat-mdc-form-field {
  margin-bottom: 0px;
  padding: 0;
}
.codeArea .mat-mdc-input-element {
  padding-left: 62px;
}
.doc-upload-field .fileWithViewImgshow,
.fileWithViewImgshow {
  position: relative !important;
  width: 100% !important;
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.doc-upload-field .fileWithViewImgshow mat-label,
.fileWithViewImgshow mat-label {
  display: block !important;
  margin-bottom: 6px !important;
  margin-top: 0 !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #3b3b3b !important;
}
.fileWithViewImgshow .fileViewImage {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 6px;
  flex-shrink: 0;
}
.fileWithViewImgshow .crossSideBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  min-height: 36px;
  padding: 0;
  border: 1px solid #dc3545;
  background: #fff;
  color: #dc3545;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  flex-shrink: 0;
}
.fileWithViewImgshow .crossSideBtn:hover {
  background: #dc3545;
  color: #fff;
}
.entity_required {
  font-size: 12px;
  margin-top: -25px;
}
.country-codes {
  margin-top: 6px;
  border-top-right-radius: 0;
}
.disable-pointer-events {
  pointer-events: none;
}
.imgWrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.file-list-wrap {
  width: 100%;
  max-height: 100px;
  overflow-y: auto;
  margin-top: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 6px;
  background: #fafafa;
}
.file-list-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 4px 8px;
  border-radius: 4px;
}
.file-list-row:hover {
  background: #f0f0f0;
}
.file-list-row + .file-list-row {
  margin-top: 4px;
}
.file-list-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #0a46a7;
}
.file-list-name:hover {
  text-decoration: underline;
}
.file-list-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #5d6c7c;
}
.file-list-row .crossSideBtn {
  flex-shrink: 0;
}
@media (max-width: 991.98px) {
  .candidateOffer .candidate_Details {
    width: 95%;
  }
  .document-row .doc-field:last-child {
    margin-bottom: 0;
  }
  .doc-actions {
    align-items: flex-start;
  }
  .action-buttons {
    width: 100%;
  }
}
@media (max-width: 767.98px) {
  .candidateOffer {
    padding: 0 8px 80px 8px;
  }
  .candidateOffer .candidate_Details {
    width: 100%;
    margin-top: 12px;
    margin-bottom: 24px;
  }
  .candidate_Details .basic_details {
    padding: 12px;
  }
  .candidate_Details .section-title,
  .candidate_Details h2 {
    padding: 10px 12px;
    font-size: 1rem;
  }
  .detail-item {
    margin-bottom: 14px;
  }
  .document-row {
    margin-bottom: 20px;
    padding-bottom: 16px;
  }
  .doc-field {
    margin-bottom: 10px;
  }
  .file-upload-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .fileRow .file-input {
    padding: 10px;
  }
  .imgWrapper {
    justify-content: flex-start;
  }
  .action-buttons {
    gap: 8px;
  }
  .btn-action {
    min-width: 44px;
    min-height: 44px;
  }
  .submit-wrap.submit-area {
    margin-top: 20px;
    padding-top: 12px;
    padding-bottom: 32px;
    text-align: center;
    margin-bottom: 0;
  }
  .btn-submit {
    width: 100%;
    max-width: 280px;
  }
  .candidate_Details .basic_details {
    padding-bottom: 24px;
  }
}
@media (max-width: 575.98px) {
  .candidateOffer {
    padding-bottom: 100px;
  }
  .submit-wrap.submit-area {
    padding-bottom: 48px;
  }
  .basic_details h5 {
    font-size: 13px;
  }
  .basic_details p {
    font-size: 12px;
  }
}
/*# sourceMappingURL=candidate-upload-doc.component.css.map */
